/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgParagraphAlt = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        d="M8.564 17.904V6.272H9.86l.288 1.296c.33-.47.73-.832 1.2-1.088.48-.256.992-.384 1.536-.384 1.11 0 1.979.389 2.608 1.168.63.768.944 1.845.944 3.232 0 1.386-.315 2.464-.944 3.232-.619.757-1.488 1.136-2.608 1.136a3.316 3.316 0 0 1-2.368-.944v3.984zm3.952-10.24c-.405 0-.79.112-1.152.336-.352.213-.64.501-.864.864v3.504c.533.629 1.205.944 2.016.944.63 0 1.11-.24 1.44-.72.341-.491.512-1.195.512-2.112 0-.918-.17-1.616-.512-2.096-.33-.48-.81-.72-1.44-.72z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgParagraphAlt as ParagraphAlt };
